import { WrapperSubMenu } from '@app/Layout/Header/Blocks';
import { PropsItemMenu } from './PropsItemMenu';
import { MyLink } from '@ui-kit/MyLink';
import classNames from 'classnames';

import styles from './ItemMenu.module.scss';

export const ItemMenu = ({ url, title, items, classSubMenu, prefix }: PropsItemMenu): JSX.Element => {
  if (!prefix) {
    prefix = 'menu';
  }

  return (
    <div className={styles.Container}>
      <MyLink className={styles.Title} href={url || ''} data-testid={`${prefix}-${url}`}>
        {title}
      </MyLink>
      <WrapperSubMenu className={classNames(styles.SubMenu, classSubMenu)} limit={11} count={items?.length} addButton={title}>
        {items?.map(x => (
          <MyLink appendTrailingSlash href={x?.url || ''} key={x.title} data-testid={`sub${prefix}-${x?.url}`}>
            <div>{x?.title}</div>
          </MyLink>
        ))}
      </WrapperSubMenu>
    </div>
  );
};
